import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/react-hooks';
import { Message, Loader } from 'semantic-ui-react';
import { toast } from 'react-toastify';

import { Container } from './styles';
import { FlexContainer, FlexChildren } from '../../components/Dashboard/styles';
import Table from '../../components/Table';
import Filter from './Filter/';
import Modal from './Modal';

import { GET_CAMERAS } from '../../services/graphql/queries';

const columns = [
  { id: 'lpr_cat_id', label: 'Id Camara', minWidth: 100 },
  { id: 'lpr_config_name', label: 'Nombre de Integracion', minWidth: 100 },
  { id: 'mall_acc_name', label: 'Nombre de Acceso', minWidth: 100 },
  { id: 'mall_name', label: 'Centro Comercial', minWidth: 100 },
  { id: 'last_update', label: 'Última actualización', minWidth: 50 },
  { id: 'active', label: 'Activo', size: 'small' },
  {
    id: 'actions',
    label: 'Acciones',
    size: 'small',
    align: 'left'
  }
];

const initialMalls = [{ key: '', value: '', text: 'Todos' }];

export default function Cameras() {
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [selected, setSelected] = useState({});
  const [filters, setFilters] = useState({});
  const [mallsOptions, setMallsOptions] = useState([]);
  const [lprConfigOptions, setLprConfigOptions] = useState([]);
  const [mallAccessOptions, setmallAccessOptions] = useState([]);

  const camerasNotification = useSelector(
    state => state.notification.camerasCount
  );

  const { loading, error, data, refetch } = useQuery(GET_CAMERAS, {
    variables: {
      mall_id: filters.mall_id,
      active: filters.active !== '' ? filters.active : undefined
    },
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (data) {
      if (data.getMalls) {
        setMallsOptions(
          data.getMalls.map(mall => ({
            key: mall.id,
            text: `${mall.name} - ${mall.code}`,
            value: mall.id,
            country_id: mall.country_id
          }))
        );
      }

      if (data.getMallAccess) {
        setmallAccessOptions(
          data.getMallAccess.map(mallAccess => ({
            key: mallAccess.id,
            text: `${mallAccess.name} - ${mallAccess.mall_code}`,
            value: mallAccess.id
          }))
        );
      }

      if (data.getLprConfig) {
        setLprConfigOptions(
          data.getLprConfig.map(lprConfig => ({
            key: lprConfig.id,
            text: lprConfig.name,
            value: lprConfig.id
          }))
        );
      }

      return () => {};
    }
  }, [data]);

  useEffect(() => {
    if (camerasNotification > 0 && camerasNotification < 2) {
      toast.warn(
        'Tienes una configuración de cámara pendiente (código de acceso con centro comercial sin asignar).',
        {
          autoClose: 7000
        }
      );
    } else if (camerasNotification > 1) {
      toast.warn(
        `Tienes ${camerasNotification} configuraciones de cámara pendientes (código de acceso con centro comercial sin asignar).`,
        {
          autoClose: 7000
        }
      );
    }
  }, [camerasNotification]);

  function handleFilterOnClick(mall_id, active) {
    setFilters({ mall_id, active });
  }

  function handleEdit(data) {
    setEdit(true);
    setSelected(data);
    setOpen(true);
  }

  function handleModalClose() {
    refetch();
    setOpen(false);
  }

  return (
    <Container data-testid="camera-component">
      <FlexContainer>
        <FlexChildren>
          <Filter
            title="Cámaras"
            onClick={handleFilterOnClick}
            malls={initialMalls.concat(mallsOptions)}
          />
          {loading && (
            <>
              <br />
              <Loader active inline="centered" />
            </>
          )}
          {error && <Message error header="Error" content={error.message} />}
          {!loading && !error && data && (
            <Table
              data={data ? data.getCameras : null}
              columns={columns}
              filters={filters}
              handleEdit={handleEdit}
            />
          )}
          <Modal
            open={open}
            onClose={handleModalClose}
            lprConfigOptions={lprConfigOptions}
            mallAccessOptions={mallAccessOptions}
            edit={edit}
            selected={selected}
          />
        </FlexChildren>
      </FlexContainer>
    </Container>
  );
}
